/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Suspense } from 'react';

import { jsx } from '@atlaskit/css';

const LazyMorphingLoaderInner = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/rovo-platform-ui-components/morphing-loader" */ './MorphingLoader'
	).then((mod) => ({ default: mod.MorphingLoader })),
);

export const LazyMorphingLoader = ({ testId }: { testId?: string }): JSX.Element => {
	return (
		<Suspense fallback={null}>
			<LazyMorphingLoaderInner testId={testId} />
		</Suspense>
	);
};
